import { Skeleton } from "antd"

import { useThemeContext } from "#contexts/ThemeContextProvider"

const CARD_COUNT = 3

/** Placeholder cards while the review's first snapshots load. */
const StandoutReviewSkeleton = () => {
  const theme = useThemeContext()
  return (
    <div
      data-testid="sr-loading"
      aria-busy="true"
      aria-label="Loading standout review"
      style={{ display: "flex", flexDirection: "column", gap: 12 }}
    >
      {Array.from({ length: CARD_COUNT }, (_, index) => (
        <div
          key={index}
          style={{
            padding: 16,
            borderRadius: 8,
            border: `1px solid ${theme.gray[4]}`,
            backgroundColor: theme.white,
          }}
        >
          <Skeleton active avatar paragraph={{ rows: 3 }} />
        </div>
      ))}
    </div>
  )
}

export default StandoutReviewSkeleton
